/* eslint-disable react-hooks/rules-of-hooks */
import React, { useEffect, useState } from 'react'

import Menu from '../../../components/Menu'
import Table from '../../../components/SupportsList'

import ReactPaginate from 'react-paginate'

import serverIcon from '../../../assets/svg/supportIcon.svg'

import { get } from '../../../services/http'

import { notify } from '../../../components/Toast'
import { ToastContainer } from 'react-toastify'

export default function index() {
  const [supports, setSupports] = useState()
  const [supportsCount, setSupportsCount] = useState()
  const [totalPage, setTotalPage] = useState()

  document.title = 'پشتیبانی'

  const token = localStorage.getItem('token')

  useEffect(() => {
    get(`/api/admin/supports?token=${token}`)
      .then(response => {
        setSupports(response.data.data.docs)
        setTotalPage(response.data.data.pages)
        setSupportsCount(response.data.data.total)
      })
      .catch(error => {
        notify('error', 'خطا در ارسال اطلاعات')
      })
  }, [token])

  const handlePageClick = (event) => {
    get(`/api/admin/supports?page=${event.selected + 1}&token=${token}`)
    .then(response => {
      setSupports(response.data.data.docs)
      setTotalPage(response.data.data.pages)
      setSupportsCount(response.data.data.total)
    }).catch(error => {
      notify('error', 'دریافت اطلاعات با خطا مواجه شد')
    })
  }

  return (
    <main id='panel'>
      <ToastContainer rtl />
      <Menu page={'support'} badgeCountDashboard={0} badgeCountOrder={0} />
      <article className='panelBody'>
        <section className='panelContent'>
          <div className='title'>
            <div className="right">
              <div className='icon'>
                <img width={22} src={serverIcon} alt='resturantIcon' />
              </div>
              <div className='text'>
                پشتیبانی
              </div>
            </div>

            <div className="left">
            </div>
          </div>

          <div className="tablePart">
            <div className="title">
              <div className="right">
                تعداد کل پشتیبانی ها
              </div>
              <div className="left">
                {supportsCount}
              </div>
            </div>

            <Table data={supports} />
            <ReactPaginate 
              breakLabel="..."
              nextLabel="بعدی"
              onPageChange={handlePageClick}
              pageRangeDisplayed={5}
              pageCount={totalPage}
              previousLabel="قبلی"
              renderOnZeroPageCount={null}
            />
          </div>

          <div className="copyright">
            © تمامی حقوق برای <a href='https://ibills.ir'>ibills</a> محفوظ است. طراحی و توسعه توسط <a href='https://ham-team.ir'>هم تیم</a>
          </div>
        </section>
      </article>
    </main>
  )
}
